function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.540894 0H4.27062L10.4868 8L4.27062 16H0.540894L6.75711 8L0.540894 0ZM7.027 0H10.7567L16.9729 8L10.7567 16H7.027L13.2432 8L7.027 0ZM17.2428 0H13.5131L19.7293 8L13.5131 16H17.2428L23.4591 8L17.2428 0Z",
  fill: "url(#paint0_linear_20026644_89366)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20026644_89366",
  x1: 0.540893,
  y1: 7.86441,
  x2: 23.4591,
  y2: 7.86441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0B54FF"
})));

function SvgBridgeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeArrow);
export default __webpack_public_path__ + "static/media/bridgeArrow.759ff2493f2646818826f7009c25c849.svg";
export { ForwardRef as ReactComponent };